import {
  reversed3umwqsxpi431x as reversed,
  firstOrNulltrxqttxfxqju as firstOrNull,
  chunked3v1tthtda414w as chunked,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { BaseListenable1u3g4s45l82o6 as BaseListenable } from '../../../../../../reactive/com/lightningkite/reactive/core/abstracts.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  get_selectionStart3uifq0rid3t9y as get_selectionStart,
  get_selectionEnd3mrxxhylrrnmx as get_selectionEnd,
  setSelectionRangez4trgvl3f63c as setSelectionRange,
  usingWebOnMobile1whyqijwjkjd1 as usingWebOnMobile,
} from './NumberField.commonHtml.js.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charCodeAt1yspne1d8erbm as charCodeAt,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { isDigit3mimrri4wkzop as isDigit } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/charJs.mjs';
import {
  _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx,
  Char19o2r8palgjof as Char,
  Char__equals_impl_x6719k3rr7u3avpyc6t as Char__equals_impl_x6719k,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  contains2el4s70rdq4ld as contains,
  substringBefore3n7kj60w69hju as substringBefore,
  substringAfter1hku067gwr5ve as substringAfter,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isCharSequence1ju9jr1w86plq as isCharSequence } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  reversed22y3au42jl32b as reversed_0,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { substringiqarkczpya5m as substring } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { commaStringeuj84z632mms as commaString } from '../../utils/backspace.mjs';
import { toDoubleOrNullkxwozihadygj as toDoubleOrNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import {
  valueSet3cf2hvvu95f3 as valueSet,
  set1y8eiqnqugbz3 as set,
  getValue6qi464mhg2s5 as getValue,
  setValue39oxnnnmdq4h2 as setValue,
  lens2e2i845xidu26 as lens,
  lens26es9640ifscs as lens_0,
  get_state389x218zizu8a as get_state,
  MutableReactiveValuettf5l2qj6mxh as MutableReactiveValue,
} from '../../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { RViewWithActionov1gis5vq13n as RViewWithAction } from '../RView.mjs';
import {
  KeyboardHints3coyq4x1rsbe3 as KeyboardHints,
  Align_Start_getInstance25tw14h3otx5g as Align_Start_getInstance,
} from '../../models/data.mjs';
import { KeyCodes_instancevfnkc2xsbiba as KeyCodes_instance } from '../../models/KeyCode.commonHtml.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function NumberInput$content$o$lambda$lambda(it) {
  return reversed(it);
}
function NumberInput$content$o$lambda$lambda_0(it) {
  return reversed(it);
}
var NumberInput$content$1Class;
function NumberInput$content$1() {
  if (NumberInput$content$1Class === VOID) {
    class $ extends BaseListenable() {
      static hc4(this$0, $box) {
        if ($box === VOID)
          $box = {};
        $box.gc4_1 = this$0;
        var $this = this.sam($box);
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_0 = this$0.tb5_1;
        var tmp0_safe_receiver = this_0.vb3_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          tmp0_safe_receiver.addEventListener('input', (it) => {
            // Inline function 'com.lightningkite.kiteui.views.valueString' call
            var tmp = this$0.tb5_1.zb3_1.ib7_1.value;
            var tmp0_elvis_lhs = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
            var tmp1_dirty = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
            var tmp2_selectionStart = get_selectionStart(this$0);
            var tmp3_selectionEnd = get_selectionEnd(this$0);
            // Inline function 'com.lightningkite.kiteui.utils.numberAutocommaRepair' call
            var allowDecimal = this$0.yc5_1.hbu_1.kc4_1;
            // Inline function 'com.lightningkite.kiteui.utils.repairFormatAndPosition' call
            // Inline function 'kotlin.text.filter' call
            // Inline function 'kotlin.text.filterTo' call
            var destination = StringBuilder().d1();
            var inductionVariable = 0;
            var last = charSequenceLength(tmp1_dirty);
            if (inductionVariable < last)
              do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var element = charSequenceGet(tmp1_dirty, index);
                if (isDigit(element) || setOf([new (Char())(_Char___init__impl__6a9atx(46)), new (Char())(_Char___init__impl__6a9atx(45))]).t1(new (Char())(element))) {
                  destination.xb(element);
                }
              }
               while (inductionVariable < last);
            var clean = destination.toString();
            var tmp0_safe_receiver = firstOrNull(clean);
            var tmp_0;
            var tmp_1 = tmp0_safe_receiver;
            if ((tmp_1 == null ? null : new (Char())(tmp_1)) == null) {
              tmp_0 = null;
            } else {
              tmp_0 = Char__equals_impl_x6719k(tmp0_safe_receiver, new (Char())(_Char___init__impl__6a9atx(45)));
            }
            var tmp1_elvis_lhs = tmp_0;
            var negative = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
            var decimal = !!(allowDecimal & contains(clean, _Char___init__impl__6a9atx(46)));
            // Inline function 'kotlin.text.filterNot' call
            // Inline function 'kotlin.text.filterNotTo' call
            var destination_0 = StringBuilder().d1();
            var inductionVariable_0 = 0;
            while (inductionVariable_0 < charSequenceLength(clean)) {
              var element_0 = charSequenceGet(clean, inductionVariable_0);
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              if (!(allowDecimal ? element_0 === _Char___init__impl__6a9atx(45) : element_0 === _Char___init__impl__6a9atx(45) || element_0 === _Char___init__impl__6a9atx(46))) {
                destination_0.xb(element_0);
              }
            }
            var value = destination_0.toString();
            // Inline function 'kotlin.text.reversed' call
            var this_0 = substringBefore(value, _Char___init__impl__6a9atx(46));
            var tmp_2 = toString(reversed(isCharSequence(this_0) ? this_0 : THROW_CCE()));
            var preDecimal = joinToString(reversed_0(chunked(tmp_2, 3, NumberInput$content$o$lambda$lambda)), ',');
            // Inline function 'kotlin.text.filterNot' call
            var tmp0 = substringAfter(value, _Char___init__impl__6a9atx(46), '');
            // Inline function 'kotlin.text.filterNotTo' call
            var destination_1 = StringBuilder().d1();
            var inductionVariable_1 = 0;
            while (inductionVariable_1 < charSequenceLength(tmp0)) {
              var element_1 = charSequenceGet(tmp0, inductionVariable_1);
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              if (!(element_1 === _Char___init__impl__6a9atx(46))) {
                destination_1.xb(element_1);
              }
            }
            var postDecimal = destination_1.toString();
            var result = !!(negative & decimal) ? '-' + preDecimal + '.' + postDecimal : negative ? '-' + preDecimal : decimal ? preDecimal + '.' + postDecimal : preDecimal;
            var tmp_3;
            if (tmp2_selectionStart == null) {
              tmp_3 = null;
            } else {
              // Inline function 'kotlin.text.count' call
              var count = 0;
              var indexedObject = substring(tmp1_dirty, 0, tmp2_selectionStart);
              var inductionVariable_2 = 0;
              while (inductionVariable_2 < charSequenceLength(indexedObject)) {
                var element_2 = charSequenceGet(indexedObject, inductionVariable_2);
                inductionVariable_2 = inductionVariable_2 + 1 | 0;
                if (!(isDigit(element_2) || setOf([new (Char())(_Char___init__impl__6a9atx(46)), new (Char())(_Char___init__impl__6a9atx(45))]).t1(new (Char())(element_2)))) {
                  count = count + 1 | 0;
                }
              }
              tmp_3 = tmp2_selectionStart - count | 0;
            }
            var startPosOnClean = tmp_3;
            var tmp_4;
            if (tmp3_selectionEnd == null) {
              tmp_4 = null;
            } else {
              // Inline function 'kotlin.text.count' call
              var count_0 = 0;
              var indexedObject_0 = substring(tmp1_dirty, 0, tmp3_selectionEnd);
              var inductionVariable_3 = 0;
              while (inductionVariable_3 < charSequenceLength(indexedObject_0)) {
                var element_3 = charSequenceGet(indexedObject_0, inductionVariable_3);
                inductionVariable_3 = inductionVariable_3 + 1 | 0;
                if (!(isDigit(element_3) || setOf([new (Char())(_Char___init__impl__6a9atx(46)), new (Char())(_Char___init__impl__6a9atx(45))]).t1(new (Char())(element_3)))) {
                  count_0 = count_0 + 1 | 0;
                }
              }
              tmp_4 = tmp3_selectionEnd - count_0 | 0;
            }
            var endPosOnClean = tmp_4;
            var tmp_5;
            if (startPosOnClean == null) {
              tmp_5 = null;
            } else {
              // Inline function 'kotlin.let' call
              var remaining = startPosOnClean;
              var count_1 = 0;
              $l$loop: while (remaining > 0 && count_1 < result.length) {
                var _unary__edvuaz = count_1;
                count_1 = _unary__edvuaz + 1 | 0;
                var it_0 = charCodeAt(result, _unary__edvuaz);
                if (isDigit(it_0) || setOf([new (Char())(_Char___init__impl__6a9atx(46)), new (Char())(_Char___init__impl__6a9atx(45))]).t1(new (Char())(it_0)))
                  remaining = remaining - 1 | 0;
              }
              tmp_5 = count_1;
            }
            var startPosOnResult = tmp_5;
            var tmp_6;
            if (endPosOnClean == null) {
              tmp_6 = null;
            } else {
              // Inline function 'kotlin.let' call
              var remaining_0 = endPosOnClean;
              var count_2 = 0;
              $l$loop_0: while (remaining_0 > 0 && count_2 < result.length) {
                var _unary__edvuaz_0 = count_2;
                count_2 = _unary__edvuaz_0 + 1 | 0;
                var it_1 = charCodeAt(result, _unary__edvuaz_0);
                if (isDigit(it_1) || setOf([new (Char())(_Char___init__impl__6a9atx(46)), new (Char())(_Char___init__impl__6a9atx(45))]).t1(new (Char())(it_1)))
                  remaining_0 = remaining_0 - 1 | 0;
              }
              tmp_6 = count_2;
            }
            var endPosOnResult = tmp_6;
            // Inline function 'com.lightningkite.kiteui.views.valueString' call
            this$0.tb5_1.zb3_1.ib7_1.value = result;
            if (!(startPosOnResult == null) && !(endPosOnResult == null)) {
              setSelectionRange(this$0, startPosOnResult, endPosOnResult);
            }
            $this.kal();
            return Unit_instance;
          });
          tmp = Unit_instance;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          var tmp_0 = this_0.eb4_1['on' + 'input'];
          var old = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
          var tmp_1 = 'on' + 'input';
          this_0.eb4_1[tmp_1] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            // Inline function 'com.lightningkite.kiteui.views.valueString' call
            var tmp = this$0.tb5_1.zb3_1.ib7_1.value;
            var tmp0_elvis_lhs = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
            var tmp1_dirty = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
            var tmp2_selectionStart = get_selectionStart(this$0);
            var tmp3_selectionEnd = get_selectionEnd(this$0);
            // Inline function 'com.lightningkite.kiteui.utils.numberAutocommaRepair' call
            var allowDecimal = this$0.yc5_1.hbu_1.kc4_1;
            // Inline function 'com.lightningkite.kiteui.utils.repairFormatAndPosition' call
            // Inline function 'kotlin.text.filter' call
            // Inline function 'kotlin.text.filterTo' call
            var destination = StringBuilder().d1();
            var inductionVariable = 0;
            var last = charSequenceLength(tmp1_dirty);
            if (inductionVariable < last)
              do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var element = charSequenceGet(tmp1_dirty, index);
                if (isDigit(element) || setOf([new (Char())(_Char___init__impl__6a9atx(46)), new (Char())(_Char___init__impl__6a9atx(45))]).t1(new (Char())(element))) {
                  destination.xb(element);
                }
              }
               while (inductionVariable < last);
            var clean = destination.toString();
            var tmp0_safe_receiver_0 = firstOrNull(clean);
            var tmp_0;
            var tmp_1 = tmp0_safe_receiver_0;
            if ((tmp_1 == null ? null : new (Char())(tmp_1)) == null) {
              tmp_0 = null;
            } else {
              tmp_0 = Char__equals_impl_x6719k(tmp0_safe_receiver_0, new (Char())(_Char___init__impl__6a9atx(45)));
            }
            var tmp1_elvis_lhs = tmp_0;
            var negative = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
            var decimal = !!(allowDecimal & contains(clean, _Char___init__impl__6a9atx(46)));
            // Inline function 'kotlin.text.filterNot' call
            // Inline function 'kotlin.text.filterNotTo' call
            var destination_0 = StringBuilder().d1();
            var inductionVariable_0 = 0;
            while (inductionVariable_0 < charSequenceLength(clean)) {
              var element_0 = charSequenceGet(clean, inductionVariable_0);
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              if (!(allowDecimal ? element_0 === _Char___init__impl__6a9atx(45) : element_0 === _Char___init__impl__6a9atx(45) || element_0 === _Char___init__impl__6a9atx(46))) {
                destination_0.xb(element_0);
              }
            }
            var value = destination_0.toString();
            // Inline function 'kotlin.text.reversed' call
            var this_0 = substringBefore(value, _Char___init__impl__6a9atx(46));
            var tmp_2 = toString(reversed(isCharSequence(this_0) ? this_0 : THROW_CCE()));
            var preDecimal = joinToString(reversed_0(chunked(tmp_2, 3, NumberInput$content$o$lambda$lambda_0)), ',');
            // Inline function 'kotlin.text.filterNot' call
            var tmp0 = substringAfter(value, _Char___init__impl__6a9atx(46), '');
            // Inline function 'kotlin.text.filterNotTo' call
            var destination_1 = StringBuilder().d1();
            var inductionVariable_1 = 0;
            while (inductionVariable_1 < charSequenceLength(tmp0)) {
              var element_1 = charSequenceGet(tmp0, inductionVariable_1);
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              if (!(element_1 === _Char___init__impl__6a9atx(46))) {
                destination_1.xb(element_1);
              }
            }
            var postDecimal = destination_1.toString();
            var result = !!(negative & decimal) ? '-' + preDecimal + '.' + postDecimal : negative ? '-' + preDecimal : decimal ? preDecimal + '.' + postDecimal : preDecimal;
            var tmp_3;
            if (tmp2_selectionStart == null) {
              tmp_3 = null;
            } else {
              // Inline function 'kotlin.text.count' call
              var count = 0;
              var indexedObject = substring(tmp1_dirty, 0, tmp2_selectionStart);
              var inductionVariable_2 = 0;
              while (inductionVariable_2 < charSequenceLength(indexedObject)) {
                var element_2 = charSequenceGet(indexedObject, inductionVariable_2);
                inductionVariable_2 = inductionVariable_2 + 1 | 0;
                if (!(isDigit(element_2) || setOf([new (Char())(_Char___init__impl__6a9atx(46)), new (Char())(_Char___init__impl__6a9atx(45))]).t1(new (Char())(element_2)))) {
                  count = count + 1 | 0;
                }
              }
              tmp_3 = tmp2_selectionStart - count | 0;
            }
            var startPosOnClean = tmp_3;
            var tmp_4;
            if (tmp3_selectionEnd == null) {
              tmp_4 = null;
            } else {
              // Inline function 'kotlin.text.count' call
              var count_0 = 0;
              var indexedObject_0 = substring(tmp1_dirty, 0, tmp3_selectionEnd);
              var inductionVariable_3 = 0;
              while (inductionVariable_3 < charSequenceLength(indexedObject_0)) {
                var element_3 = charSequenceGet(indexedObject_0, inductionVariable_3);
                inductionVariable_3 = inductionVariable_3 + 1 | 0;
                if (!(isDigit(element_3) || setOf([new (Char())(_Char___init__impl__6a9atx(46)), new (Char())(_Char___init__impl__6a9atx(45))]).t1(new (Char())(element_3)))) {
                  count_0 = count_0 + 1 | 0;
                }
              }
              tmp_4 = tmp3_selectionEnd - count_0 | 0;
            }
            var endPosOnClean = tmp_4;
            var tmp_5;
            if (startPosOnClean == null) {
              tmp_5 = null;
            } else {
              // Inline function 'kotlin.let' call
              var remaining = startPosOnClean;
              var count_1 = 0;
              $l$loop_1: while (remaining > 0 && count_1 < result.length) {
                var _unary__edvuaz = count_1;
                count_1 = _unary__edvuaz + 1 | 0;
                var it_0 = charCodeAt(result, _unary__edvuaz);
                if (isDigit(it_0) || setOf([new (Char())(_Char___init__impl__6a9atx(46)), new (Char())(_Char___init__impl__6a9atx(45))]).t1(new (Char())(it_0)))
                  remaining = remaining - 1 | 0;
              }
              tmp_5 = count_1;
            }
            var startPosOnResult = tmp_5;
            var tmp_6;
            if (endPosOnClean == null) {
              tmp_6 = null;
            } else {
              // Inline function 'kotlin.let' call
              var remaining_0 = endPosOnClean;
              var count_2 = 0;
              $l$loop_2: while (remaining_0 > 0 && count_2 < result.length) {
                var _unary__edvuaz_0 = count_2;
                count_2 = _unary__edvuaz_0 + 1 | 0;
                var it_1 = charCodeAt(result, _unary__edvuaz_0);
                if (isDigit(it_1) || setOf([new (Char())(_Char___init__impl__6a9atx(46)), new (Char())(_Char___init__impl__6a9atx(45))]).t1(new (Char())(it_1)))
                  remaining_0 = remaining_0 - 1 | 0;
              }
              tmp_6 = count_2;
            }
            var endPosOnResult = tmp_6;
            // Inline function 'com.lightningkite.kiteui.views.valueString' call
            this$0.tb5_1.zb3_1.ib7_1.value = result;
            if (!(startPosOnResult == null) && !(endPosOnResult == null)) {
              setSelectionRange(this$0, startPosOnResult, endPosOnResult);
            }
            $this.kal();
            return Unit_instance;
          };
        }
        return $this;
      }
      bc6(value) {
        // Inline function 'com.lightningkite.kiteui.views.valueString' call
        var tmp = this.gc4_1.tb5_1.zb3_1.ib7_1.value;
        var tmp_0 = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
        if (!(tmp_0 == (value == null ? null : commaString(value)))) {
          var tmp0 = this.gc4_1.tb5_1.zb3_1;
          // Inline function 'com.lightningkite.kiteui.views.valueString' call
          var value_0 = value == null ? null : commaString(value);
          tmp0.ib7_1.value = value_0;
        }
      }
      mam(_set____db54di) {
        return this.bc6((_set____db54di == null ? true : typeof _set____db54di === 'number') ? _set____db54di : THROW_CCE());
      }
      f2() {
        // Inline function 'com.lightningkite.kiteui.views.valueString' call
        var tmp = this.gc4_1.tb5_1.zb3_1.ib7_1.value;
        var tmp0_safe_receiver = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.text.filter' call
          // Inline function 'kotlin.text.filterTo' call
          var destination = StringBuilder().d1();
          var inductionVariable = 0;
          var last = charSequenceLength(tmp0_safe_receiver);
          if (inductionVariable < last)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var element = charSequenceGet(tmp0_safe_receiver, index);
              if (isDigit(element) || setOf([new (Char())(_Char___init__impl__6a9atx(45)), new (Char())(_Char___init__impl__6a9atx(46))]).t1(new (Char())(element))) {
                destination.xb(element);
              }
            }
             while (inductionVariable < last);
          tmp_0 = destination.toString();
        }
        var tmp1_safe_receiver = tmp_0;
        return tmp1_safe_receiver == null ? null : toDoubleOrNull(tmp1_safe_receiver);
      }
      oam(thisRef, property) {
        return this.nam((thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE(), property);
      }
      qam(thisRef, property, value) {
        var tmp = (thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE();
        return this.pam(tmp, property, (value == null ? true : typeof value === 'number') ? value : THROW_CCE());
      }
    }
    protoOf($).cak = valueSet;
    protoOf($).gah = set;
    protoOf($).nam = getValue;
    protoOf($).pam = setValue;
    protoOf($).tak = lens;
    protoOf($).bak = lens_0;
    protoOf($).qah = get_state;
    initMetadataForClass($, VOID, VOID, VOID, [MutableReactiveValue(), BaseListenable()], [1]);
    NumberInput$content$1Class = $;
  }
  return NumberInput$content$1Class;
}
var NumberInputClass;
function NumberInput() {
  if (NumberInputClass === VOID) {
    class $ extends RViewWithAction() {
      constructor(context) {
        super(context);
        this.tb5_1.xb3_1 = 'input';
        this.tb5_1.hb4_1.v('editable');
        var tmp = this;
        tmp.xc5_1 = NumberInput$content$1().hc4(this);
        this.yc5_1 = new (KeyboardHints())();
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_0 = this.tb5_1;
        var tmp0_safe_receiver = this_0.vb3_1;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          tmp0_safe_receiver.addEventListener('keyup', (it) => {
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            if (it.code === KeyCodes_instance.gax()) {
              var tmp0_safe_receiver = this.kbg_1;
              if (tmp0_safe_receiver == null)
                null;
              else {
                tmp0_safe_receiver.xbe(this);
              }
            }
            return Unit_instance;
          });
          tmp_0 = Unit_instance;
        }
        if (tmp_0 == null) {
          // Inline function 'kotlin.run' call
          var tmp_1 = this_0.eb4_1['on' + 'keyup'];
          var old = (!(tmp_1 == null) ? typeof tmp_1 === 'function' : false) ? tmp_1 : null;
          var tmp_2 = 'on' + 'keyup';
          this_0.eb4_1[tmp_2] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            if (it.code === KeyCodes_instance.gax()) {
              var tmp0_safe_receiver_0 = this.kbg_1;
              if (tmp0_safe_receiver_0 == null)
                null;
              else {
                tmp0_safe_receiver_0.xbe(this);
              }
            }
            return Unit_instance;
          };
        }
        this.zc5_1 = Align_Start_getInstance();
        this.ac6_1 = null;
      }
      abs(value) {
        this.yc5_1 = value;
        var tmp0 = this.tb5_1.zb3_1;
        var tmp;
        switch (value.hbu_1.b4_1) {
          case 0:
            tmp = 'text';
            break;
          case 3:
            tmp = 'text';
            break;
          case 1:
            tmp = 'text';
            break;
          case 2:
            tmp = 'tel';
            break;
          case 4:
            tmp = 'text';
            break;
          case 5:
            tmp = 'text';
            break;
          case 6:
            tmp = 'text';
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        // Inline function 'com.lightningkite.kiteui.views.type' call
        var value_0 = tmp;
        tmp0.ib7_1.type = value_0;
        var tmp0_0 = this.tb5_1.zb3_1;
        var tmp_0;
        switch (value.hbu_1.b4_1) {
          case 0:
            tmp_0 = 'text';
            break;
          case 3:
            tmp_0 = 'decimal';
            break;
          case 1:
            tmp_0 = 'numeric';
            break;
          case 2:
            tmp_0 = 'tel';
            break;
          case 4:
            tmp_0 = 'email';
            break;
          case 5:
            tmp_0 = usingWebOnMobile() ? 'text' : 'numeric';
            break;
          case 6:
            tmp_0 = usingWebOnMobile() ? 'text' : 'decimal';
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        // Inline function 'com.lightningkite.kiteui.views.inputMode' call
        var value_1 = tmp_0;
        tmp0_0.ib7_1.inputMode = value_1;
        var tmp2_subject = value.ibu_1;
        switch (tmp2_subject == null ? -1 : tmp2_subject.b4_1) {
          case 0:
            // Inline function 'com.lightningkite.kiteui.views.type' call

            this.tb5_1.zb3_1.ib7_1.type = 'email';
            // Inline function 'com.lightningkite.kiteui.views.autocomplete' call

            this.tb5_1.zb3_1.ib7_1.autocomplete = 'email';
            break;
          case 1:
            var tmp0_1 = this.tb5_1.zb3_1;
            // Inline function 'com.lightningkite.kiteui.views.type' call

            var value_2 = 'password';
            tmp0_1.ib7_1.type = value_2;
            var tmp0_2 = this.tb5_1.zb3_1;
            // Inline function 'com.lightningkite.kiteui.views.autocomplete' call

            var value_3 = 'current-password';
            tmp0_2.ib7_1.autocomplete = value_3;
            break;
          case 2:
            var tmp0_3 = this.tb5_1.zb3_1;
            // Inline function 'com.lightningkite.kiteui.views.type' call

            var value_4 = 'password';
            tmp0_3.ib7_1.type = value_4;
            var tmp0_4 = this.tb5_1.zb3_1;
            // Inline function 'com.lightningkite.kiteui.views.autocomplete' call

            var value_5 = 'new-password';
            tmp0_4.ib7_1.autocomplete = value_5;
            break;
          case 3:
            // Inline function 'com.lightningkite.kiteui.views.autocomplete' call

            this.tb5_1.zb3_1.ib7_1.autocomplete = 'tel';
            break;
          case 4:
          case -1:
            // Inline function 'com.lightningkite.kiteui.views.autocomplete' call

            this.tb5_1.zb3_1.ib7_1.autocomplete = 'off';
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
      }
      bbs(value) {
        this.zc5_1 = value;
        var tmp0 = this.tb5_1.bb4_1;
        var tmp;
        switch (value.b4_1) {
          case 0:
            tmp = 'start';
            break;
          case 1:
            tmp = 'center';
            break;
          case 2:
            tmp = 'end';
            break;
          case 3:
            tmp = 'justify';
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        // Inline function 'com.lightningkite.kiteui.views.textAlign' call
        var value_0 = tmp;
        tmp0.fb7_1.textAlign = value_0;
      }
      cc6(value) {
        this.ac6_1 = value;
        var tmp;
        if (value == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          var tmp0 = this.tb5_1.zb3_1;
          // Inline function 'com.lightningkite.kiteui.views.maxDouble' call
          var value_0 = value.j1();
          tmp0.ib7_1.max = value_0;
          var tmp0_0 = this.tb5_1.zb3_1;
          // Inline function 'com.lightningkite.kiteui.views.maxDouble' call
          var value_1 = value.k1();
          tmp0_0.ib7_1.max = value_1;
          tmp = Unit_instance;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          // Inline function 'com.lightningkite.kiteui.views.maxDouble' call
          this.tb5_1.zb3_1.ib7_1.max = null;
          // Inline function 'com.lightningkite.kiteui.views.maxDouble' call
          this.tb5_1.zb3_1.ib7_1.max = null;
        }
      }
      cbs(value) {
        var tmp0 = this.tb5_1.zb3_1;
        // Inline function 'com.lightningkite.kiteui.views.disabled' call
        var value_0 = !value;
        tmp0.ib7_1.disabled = value_0;
      }
      dbs() {
        // Inline function 'com.lightningkite.kiteui.views.disabled' call
        var tmp = this.tb5_1.zb3_1.ib7_1.disabled;
        var tmp0_elvis_lhs = (!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null;
        return !(tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs);
      }
    }
    initMetadataForClass($, 'NumberInput');
    NumberInputClass = $;
  }
  return NumberInputClass;
}
//region block: exports
export {
  NumberInput as NumberInput16nzuc28fuw7p,
};
//endregion

//# sourceMappingURL=NumberField.commonHtml.mjs.map
